import React, { Component } from 'react';
import DescriptiveText from './components/descriptiveText.js';
import CustomerHero from './components/customerHero';
import WebscreenSingle from './components/webscreenSingle';
import WebscreenDouble from './components/webscreenDouble';
import WebscreenMobile from './components/webscreenMobile';
import CustomerQuote from './components/customerQuote';
import Footer from './components/footer';

export default class Threadloom extends Component {
  constructor(props) {
      super(props);
      this.state = {
  			animations: []
  		};
  }
  componentDidMount() {
  }
  render() {
    return (
      <div className="white-background">
        <CustomerHero company="Threadloom"
          title="A Silicon Valley based company raising the bar in forum performance"
          video=""
          backgroundImage="images/threadloom-hero.jpg"
          overlayColor="rgb(67,151,246)"
        />
        <div className="large-margin-top">
          <DescriptiveText
              title="Company Overview"
              text="Threadloom is a Silicon Valley based startup changing the way people interact with forums by providing valuable tools to forum owners that are powered by machine learning."
            />
            <WebscreenSingle
              image="images/threadloom-long.jpg"
            />
            <DescriptiveText
              title="A Collaborative Dream Team"
              text="Threadloom was in need of a bolt-on design team that could work closely with their brand and utilize the latest technology to communicate their message in an artful manner. Alpine Design and Threadloom proved that together they could accomplish tremendous results."
            />
            <WebscreenDouble
              image1="images/threadloom-side-by-side-1.jpg"
              image2="images/threadloom-side-by-side-2.jpg"
            />
            <DescriptiveText
              title="A Multi-platform Focus"
              text="It is important for a website to automatically adapt to whatever screen size or device it is being viewed on. Threadloom was built using our in-house frontend custom framework that is focused on responsive design providing optimum results."
            />
            <WebscreenMobile
              image1="images/threadloom-mobile-1.png"
              image2="images/threadloom-mobile-2.png"
              image3="images/threadloom-mobile-3.png"
            />
            <DescriptiveText
              title="Intuitive Dashboard and E-Commerce Capabilities"
              text="Threadloom provides its users with an option to set up an account and purchase service plans through their website. To best streamline the signup process, we integrated an e-commerce solution and custom backend dashboard that could seamlessly blend with the overall flow of the website."
            />
            <div className="medium-padding">
              <WebscreenSingle
                image="images/threadloom-long-2.jpg"
              />
            </div>
            <div className="medium-padding">
              <WebscreenSingle
                image="images/threadloom-dashboard.jpg"
              />
            </div>
        </div>
		<CustomerQuote
              thumb="images/threadloom-quote-thumb.jpg"
              name="Paul Lee, CEO and Co-Founder, Threadloom, Inc."
              overlayColor="rgb(67,151,246)"
              quote="We've worked with Kathryn and Jeff at Alpine Design on several projects.  They've surpassed our expectations every time.  Not only are their technical and design chops solid, they're also a ton of fun to work with and great people – I genuinely look forward to our meetings with them! They're also great communicators and listeners, which I've found to be extremely helpful when translating design ideas into a product for our audience.  If you're looking for someone to help you with your website or other design work, I highly recommend Alpine Design."
              backgroundImage="images/threadloom-quote-background.jpg"
            />
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/threadloom.js